var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-contact-list" },
    [
      !_vm.hasSelected
        ? _c(
            "v-menu",
            {
              attrs: {
                value: _vm.showMenu,
                "offset-y": "",
                "close-on-content-click": false,
                "close-on-click": false,
                "nudge-bottom": 4,
                "content-class": "search-contact-list__menu",
                "max-height": "240"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "div",
                          _vm._g(_vm._b({}, "div", attrs, false), on),
                          [
                            _c("input-by-type", {
                              staticClass: "align-icon-search",
                              attrs: {
                                value: _vm.searchQuery,
                                labelExternal: _vm.label,
                                placeholder: _vm.placeholder,
                                dense: "",
                                outlined: "",
                                "hide-details": "",
                                "prepend-inner-icon": "mdi-magnify",
                                loading: _vm.loading
                              },
                              on: { input: _vm.onInput }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                1121491401
              )
            },
            [
              _vm.hasResults
                ? _c(
                    "v-list",
                    { staticClass: "pa-0" },
                    _vm._l(_vm.items, function(item) {
                      return _c(
                        "v-list-item",
                        {
                          key: item.id,
                          staticClass: "search-contact-list__item",
                          on: {
                            click: function($event) {
                              return _vm.onSelect(item)
                            }
                          }
                        },
                        [
                          _vm._t(
                            "item",
                            [
                              _c(
                                "v-avatar",
                                {
                                  staticClass: "mr-4 flex-shrink-0",
                                  attrs: { size: "28", color: "grey lighten-2" }
                                },
                                [
                                  _c("span", { staticClass: "az-text-small" }, [
                                    _vm._v(_vm._s(_vm.getInitial(item)))
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "flex-grow-1 overflow-hidden" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "az-text-primary az-size-14 font-medium text-truncate"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.getDisplayName(item)) +
                                          " "
                                      ),
                                      _vm.getSecondaryName(item)
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "az-text-small az-muted ml-1"
                                            },
                                            [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(
                                                    _vm.getSecondaryName(item)
                                                  ) +
                                                  ") "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm.getSubtitle(item)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "az-text-small az-muted text-truncate"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.getSubtitle(item)) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            { item: item }
                          )
                        ],
                        2
                      )
                    }),
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "d-flex justify-center align-center pa-4" },
                    [
                      _c("span", { staticClass: "az-text-small az-muted" }, [
                        _vm._v(_vm._s(_vm.noResultsText))
                      ])
                    ]
                  )
            ],
            1
          )
        : _vm._e(),
      _vm.hasSelected
        ? _c("div", [
            _c("div", { staticClass: "az-text-label" }, [
              _vm._v(_vm._s(_vm.label))
            ]),
            _c(
              "div",
              {
                staticClass:
                  "search-contact-list__selected d-flex align-center",
                style: { backgroundColor: _vm.selectedBgColor }
              },
              [
                _vm._t(
                  "selected",
                  [
                    _c(
                      "v-avatar",
                      {
                        staticClass: "mr-2 flex-shrink-0",
                        attrs: { size: "28", color: "primary" }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "white--text",
                            staticStyle: { "font-size": "12px" }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.getInitial(_vm.selected)) + " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c("div", { staticClass: "flex-grow-1 overflow-hidden" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "az-text-primary az-size-14 font-medium text-truncate"
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.getDisplayName(_vm.selected)) + " "
                          )
                        ]
                      ),
                      _vm.getSubtitle(_vm.selected)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "az-text-small az-muted text-truncate"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getSubtitle(_vm.selected)) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1",
                        attrs: { icon: "", "x-small": "" },
                        on: { click: _vm.onClear }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: _vm.icons.close,
                            size: "14",
                            color: "#8E8E8E"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  { item: _vm.selected, onClear: _vm.onClear }
                )
              ],
              2
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }